import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import PopupModalTable from './PopupModalTable';

const PopupModal = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Popup Modal' parent='Popup Modal' />
      <Container fluid={true}>
        <Row>
          <PopupModalTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default PopupModal;
